import { render, staticRenderFns } from "./FormsCustomersSave.vue?vue&type=template&id=77bae078&scoped=true"
import script from "./FormsCustomersSave.vue?vue&type=script&lang=js"
export * from "./FormsCustomersSave.vue?vue&type=script&lang=js"
import style0 from "./FormsCustomersSave.vue?vue&type=style&index=0&id=77bae078&prod&language=scss&scoped=true&lang=css"
import style1 from "./FormsCustomersSave.vue?vue&type=style&index=1&id=77bae078&prod&language=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bae078",
  null
  
)

export default component.exports